import { FC, memo } from 'react';

type Props = {
  token: string;
};

// Memoized token prevents re-render of already visible tokens when new ones arrive
export const StreamingToken: FC<Props> = memo(({ token }) => <span className="animate-token-appear">{token}</span>);
StreamingToken.displayName = 'StreamingToken';
